import React, { useEffect } from "react";
import { Box, Grid2 as Grid, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import BarChartIcon from "@mui/icons-material/BarChart";
import styled from "styled-components";
import AdadotLink from "src/components/link";
import { TeamsProvider } from "src/scenes/teams/teams-provider";
import TeamSelect from "src/scenes/overview/overview-components/team-select";
import BreakdownSwitch from "src/scenes/overview/overview-components/overview-breakdown-switch";
import { Outlet, useLocation } from "react-router-dom";
import OverviewProvider from "src/components/providers/overview-provider";
import { Helmet } from "react-helmet";
import Portal from "src/components/portal";
import DemoBarPersonal from "src/components/demo-bar-personal";
import DemoBarDemo from "src/components/demo-bar-demo";
import AiInsightsSection from "src/components/ai-insights/ai-insights-section";

const OverviewButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 12px;
    z-index: 10;
    text-align: center;
    padding-right: 12px;
    &:hover {
        border-bottom: none;
    }
`;

const HeaderText = styled.p`
    margin: 0;
`;

const Overview = () => {
    const [isAnalyticsView, setIsAnalyticsView] = React.useState(false);

    const { pathname, search } = useLocation();

    useEffect(() => {
        if (pathname) {
            const pathnameSplit = pathname.split("/");
            const path = pathnameSplit[pathnameSplit.length - 1];
            setIsAnalyticsView(path === "details");
        }
    }, [pathname]);

    return (
        <TeamsProvider>
            <OverviewProvider>
                <Helmet>
                    <title>Adadot - Executive Overview</title>
                </Helmet>
                <Portal>
                    <DemoBarPersonal />
                    <DemoBarDemo />
                </Portal>
                <Box sx={{ width: "100%", overflowX: "hidden", paddingTop: 0 }}>
                    <Grid container spacing={2} direction="column" mb={8} style={{ width: "100%" }}>
                        <Grid id="header">
                            <Grid container direction="row" justifyContent="space-between">
                                <Grid container direction="row" alignItems="center" spacing={2}>
                                    <Grid>
                                        <HeaderText>Time Investment analytics for</HeaderText>
                                    </Grid>
                                    <Grid p={1}>
                                        <TeamSelect />
                                    </Grid>
                                    <Grid>{!isAnalyticsView && <BreakdownSwitch />}</Grid>
                                </Grid>
                                <Grid>
                                    <Stack direction="row" spacing={1}>
                                        <OverviewButton
                                            component={AdadotLink}
                                            to={{
                                                pathname: isAnalyticsView
                                                    ? "/overview"
                                                    : "/overview/details",
                                                search,
                                            }}
                                            variant="text"
                                            color="secondary"
                                            onClick={() => setIsAnalyticsView(!isAnalyticsView)}
                                            startIcon={
                                                isAnalyticsView ? (
                                                    <ArrowBackIosNewIcon />
                                                ) : (
                                                    <BarChartIcon />
                                                )
                                            }
                                            endIcon={
                                                isAnalyticsView ? (
                                                    <AutoAwesomeMosaicIcon />
                                                ) : (
                                                    <ArrowForwardIosIcon />
                                                )
                                            }
                                        >
                                            {isAnalyticsView ? "Go to Overview" : "Go to Analytics"}
                                        </OverviewButton>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid id="ia-insights" sx={{ width: "100%" }}>
                            <AiInsightsSection />
                        </Grid>
                        <Grid id="overview" sx={{ width: "100%" }}>
                            <Outlet />
                        </Grid>
                    </Grid>
                </Box>
            </OverviewProvider>
        </TeamsProvider>
    );
};

export default Overview;
